import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

interface IOutputDestinationDialogProps {
    dialogName: string;
    handleDownload?: () => void;
    hideDialog: () => void;
}

const OutputDestinationDialog = (props: IOutputDestinationDialogProps) => {
    const { register, errors } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('OutputDestinationDialog onCreate()');
    };

    const downloadClicked = () => {
        props.handleDownload();
        props.hideDialog();
    };

    return (
        <Dialog title="Output Destination" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Download'}
                    onClick={() => downloadClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem', marginLeft: '20rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
            <RHFInputBox
                name={''}
                type="text"
                register={register}
                errors={errors}
                style={{ width: '100%' }}
                bodyStyle={{ width: '100%' }}
                disabled={true}
            />
        </Dialog>
    );
};

export default OutputDestinationDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/OutputDestinationDialog.tsx